<main class="login-page">
  <button
    type="button"
    class="theme-toggle"
    (click)="theme.toggle()"
    [attr.aria-label]="theme.theme() === 'dark' ? 'Use light mode' : 'Use dark mode'"
    [attr.title]="theme.theme() === 'dark' ? 'Use light mode' : 'Use dark mode'"
  >
    {{ theme.theme() === 'dark' ? '☀' : '☾' }}
  </button>

  @if (showRoleChooser()) {
    <section class="card chooser-screen">
      @if (error()) {
        <p class="error" role="alert">{{ error() }}</p>
      }
      <app-role-chooser
        [displayName]="chooserDisplayName()"
        [roles]="chooserRoles()"
        [busy]="busy()"
        (choose)="onRoleChosen($event)"
        (signOut)="signOutFromChooser()"
      />
    </section>
  } @else {
    <section class="card">
      <header class="head">
        <p class="app-title">Jansunwai</p>
        <img
          class="logo"
          src="/deoria-government-logo.jpg"
          alt="Government of Uttar Pradesh"
        />
        <h1>Login</h1>
        <p class="sub">Deoria district employees only</p>
      </header>

      <div class="mode-tabs" role="tablist" aria-label="Sign-in method">
        <button
          type="button"
          role="tab"
          class="mode-tab"
          [class.active]="mode === 'password'"
          [attr.aria-selected]="mode === 'password'"
          (click)="setMode('password')"
        >
          Password
        </button>
        <button
          type="button"
          role="tab"
          class="mode-tab"
          [class.active]="mode === 'otp'"
          [attr.aria-selected]="mode === 'otp'"
          (click)="setMode('otp')"
        >
          OTP
        </button>
      </div>

      @if (mode === 'password') {
        <form (ngSubmit)="submitAdmin()">
          <label>
            Username
            <input
              [(ngModel)]="username"
              name="username"
              autocomplete="username"
              required
            />
          </label>

          <label>
            Password
            <input
              [(ngModel)]="password"
              name="password"
              type="password"
              autocomplete="current-password"
              placeholder="Enter password"
              required
            />
          </label>

          @if (error()) {
            <p class="error" role="alert">{{ error() }}</p>
          }

          <button type="submit" class="login-btn" [disabled]="busy()">Login</button>
        </form>
      } @else if (otpStep === 'request') {
        <form (ngSubmit)="requestOtp()">
          <fieldset class="channel">
            <legend>Send OTP to</legend>
            <label class="radio">
              <input
                type="radio"
                name="otpChannel"
                [(ngModel)]="otpChannel"
                value="email"
                (ngModelChange)="onOtpChannelChange($event)"
              />
              Email
            </label>
            <label class="radio">
              <input
                type="radio"
                name="otpChannel"
                [(ngModel)]="otpChannel"
                value="mobile"
                (ngModelChange)="onOtpChannelChange($event)"
              />
              Mobile
            </label>
          </fieldset>

          @if (otpChannel === 'email') {
            <label>
              Email address
              <input
                [(ngModel)]="otpDestination"
                name="otpEmail"
                type="email"
                autocomplete="email"
                placeholder="Enter your registered email"
                required
              />
            </label>
          } @else {
            <label>
              Mobile number
              <input
                [(ngModel)]="otpDestination"
                name="otpMobile"
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                placeholder="Enter your registered mobile"
                required
              />
            </label>
          }

          @if (info()) {
            <p class="info" role="status">{{ info() }}</p>
          }
          @if (error()) {
            <p class="error" role="alert">{{ error() }}</p>
          }

          <button
            type="submit"
            class="login-btn"
            [disabled]="busy() || !otpDestination.trim()"
          >
            {{ busy() ? 'Sending…' : 'Send OTP' }}
          </button>
        </form>
      } @else {
        <form (ngSubmit)="verifyOtp()">
          <p class="info" role="status">
            Enter the code sent to <strong>{{ destinationMasked }}</strong>
          </p>

          <p
            class="otp-timer"
            [class.expired]="otpExpiresIn() <= 0"
            role="timer"
            [attr.aria-live]="'polite'"
          >
            @if (otpExpiresIn() > 0) {
              Code expires in <strong>{{ formatMmSs(otpExpiresIn()) }}</strong>
            } @else {
              OTP expired — please resend a new code
            }
          </p>

          <label>
            One-time password
            <input
              [(ngModel)]="otp"
              name="otp"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
              placeholder="6-digit code"
              required
              [disabled]="otpExpiresIn() <= 0"
            />
          </label>

          @if (error()) {
            <p class="error" role="alert">{{ error() }}</p>
          }

          <button
            type="submit"
            class="login-btn"
            [disabled]="busy() || otp.trim().length < 4 || otpExpiresIn() <= 0"
          >
            {{ busy() ? 'Verifying…' : 'Verify & sign in' }}
          </button>

          <div class="otp-actions">
            <button
              type="button"
              class="linkish"
              [disabled]="busy() || resendIn() > 0"
              (click)="resendOtp()"
            >
              @if (resendIn() > 0) {
                Resend in {{ formatMmSs(resendIn()) }}
              } @else {
                Resend OTP
              }
            </button>
            <button type="button" class="linkish" [disabled]="busy()" (click)="backToOtpRequest()">
              Change details
            </button>
          </div>
        </form>
      }

      <div class="links">
        <a href="mailto:support@jansunwai.gov.in?subject=Forgot%20Password">Forgot Password</a>
      </div>
    </section>
  }

  <footer class="footer">
    <a routerLink="/">← Back to home</a>
    <span>© Government of Uttar Pradesh · Jansunwai</span>
  </footer>
</main>
